export const generateKey = (inputString, index) => {
  try {
    if (inputString) {
      while (inputString.length < 10) {
        inputString += inputString;
      }

      return `${inputString.slice(0, 10)}-${index}`;
    } else {
      return `generic-${index}`;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};